import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const LIMITED_LIB_PARTNERSHIP = 'Limited Liability Partnership';
const BusinessType = ({ values }) => (
  <Content>
    {({
      businessTypeError = '',
      businessTypeLabel = '',
      businessTypeLimitedWithDirector = '',
      businessTypeLimitedCompany,
      businessTypeSole = '',
      businessTypeLimitedWithMult = '',
      businessTypeLimitedPartnership = '',
      legalStructureText = ''
    }) => (
      <Field name="businessTypeField" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error }, input }) => (
          <Field
            name="businessTypeField"
            value={businessTypeSole}
            type="radio"
            validate={isRequired}
          >
            {({ input }) => (
              <GenericFieldWrapper
                inputId="businessTypeField"
                title={businessTypeLabel}
                description={legalStructureText}
                validationMessage={touched && error ? businessTypeError : ''}
              >
                <GenericRadio.StackedSet
                  groupName="businessType-group"
                  items={[
                    { id: businessTypeSole, labelText: businessTypeSole },
                    { id: businessTypeLimitedCompany, labelText: businessTypeLimitedWithDirector },
                    { id: businessTypeLimitedWithMult, labelText: businessTypeLimitedWithMult },
                    { id: LIMITED_LIB_PARTNERSHIP, labelText: businessTypeLimitedPartnership }
                  ]}
                  selectedId={values.businessTypeField}
                  {...input}
                />
              </GenericFieldWrapper>
            )}
          </Field>
        )}
      </Field>
    )}
  </Content>
);

export default BusinessType;
